import React from 'react';
import { Link } from 'react-router-dom';

import { $ } from 'jquery';
import Swal from 'sweetalert2';
import MUIDataTable from 'mui-datatables';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Toggle from 'react-toggle';
import { FaEye } from 'react-icons/fa';
import { getDateWisePayments } from '../../actions';
import moment from 'moment';

class PaymentList extends React.Component {
  state = {
    paymentList: [],
  };

  // handleStatusChange = (sid) => {
  //   var isChecked = $('#cattogBtn_' + sid);
  //   isChecked.prop("checked", !isChecked.prop("checked"));
  //   console.log(isChecked.prop('checked'), !isChecked.prop("checked"));
  //   if (!isChecked.prop("checked") === true) {
  //     var status = 'active'
  //   } else {
  //     var status = 'inactive'
  //   }
  //   let newArray = this.state.user_list;
  //   var a = newArray.find((element) => {
  //     return element.id === sid
  //   })
  //   a.status = status;
  //   console.log(newArray)
  //   this.setState({ user_list: newArray })
  //   Swal.fire("Update Status!", "Status has been updated.", "success");
  // }

  componentWillReceiveProps(nextProps) {
    if (this.props.home.paymentList !== undefined) {
      let paymentList = this.props.home.paymentList;
      //console.log("userList")
      this.setState({
        paymentList,
      });
    }
  }

  componentDidMount() {
    this.props.getDateWisePayments();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.home.paymentList !== this.props.home.paymentList &&
      this.props.home.paymentList === undefined
    ) {
      this.props.getDateWisePayments();
    }
  }

  render() {
    const columns = [
      //   {
      //   name: "Medium",
      //   label: "Image",
      //   options: {
      //     filter: false,
      //     sort: false,
      //     customBodyRender: (Medium, tableMeta) => {
      //       return <img src={Medium !== undefined && Medium !== null && Medium !== {} ? Medium.url !== undefined && Medium.url !== null && Medium.url !== "" ? Medium.url : "./assets/images/icon.png" : "./assets/images/icon.png"} className="img-fluid img-20" alt="" onError={this.imgLoadError} />
      //     }
      //   }
      // },
      {
        name: 'username',
        label: 'Username',
        options: {
          filter: false,
          sort: true,
        },
      },
      {
        name: 'createdAt',
        label: 'Payment Date',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (createdAt) => {
            return moment(createdAt).format('DD/MM/YYYY , hh:mm A');
          },
        },
      },
      {
        name: 'packageId',
        label: 'Package',
        options: {
          filter: false,
          sort: true,
        },
      },
      {
        name: 'packageName',
        label: 'Membership',
        options: {
          filter: false,
          sort: true,
        },
      },
      {
        name: 'amount',
        label: 'Amount',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (amount) => (amount != null ? `${amount} KWD` : '—'),
        },
      },
      {
        name: 'paymentType',
        label: 'Payment Method',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (paymentType) => paymentType || '—',
        },
      },
      // {
      //   name: 'active',
      //   label: 'Status',
      //   options: {
      //     filter: false,
      //     sort: true,
      //     customBodyRender: (active) => {
      //       return (
      //         <div className={active ? 'st-active' : 'st-inactive'}>
      //           {active ? 'Active' : 'In-Active'}
      //         </div>
      //       );
      //     },
      //   },
      // },
      {
        name: 'userStatus',
        label: 'User Status',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (userStatus) => {
            switch (userStatus) {
              case 'active':
                return <div className="st-active">Active</div>;
              case 'in-active':
                return <div className="st-inactive">Inactive</div>;
              default: //status === delete
                return <div className="text-danger">Deleted</div>;
            }
          },
        },
      },
      {
        name: 'subscriptionId',
        label: 'Actions',
        options: {
          filter: false,
          sort: false,
          customBodyRender: (subscriptionId) => (
            <Link to={`/payment/view/${subscriptionId}`} title="View receipt">
              <FaEye style={{ fontSize: '1.3rem' }} />
            </Link>
          ),
        },
      },
      // {
      //   name: 'expiry',
      //   label: 'Last Membership Expiry',
      //   options: {
      //     filter: false,
      //     sort: true,
      //     customBodyRender: (expiry) => {
      //       return moment(expiry).format('DD/MM/YYYY');
      //     },
      //   },
      // },
      // {
      //   name: 'status',
      //   label: 'Status',
      //   options: {
      //     filter: true,
      //     sort: true,
      //     customBodyRender: (status, tableMeta) => {
      //       var Id = tableMeta.rowData[6];
      //       // console.log(tableMeta.rowData[6]);
      //       return (
      //         <Toggle
      //           id={'status_' + Id}
      //           checked={status}
      //           value={status}
      //           onChange={this.handleStatusChange.bind(this, Id, status)}
      //         />
      //       );
      //     },
      //   },
      // },
      // {
      //   name: 'id',
      //   label: 'Action',
      //   options: {
      //     filter: true,
      //     sort: true,
      //     customBodyRender: (id, tableMeta) => {
      //       return (
      //         <div>
      //           <Link
      //             to={'/payment/edit/' + id}
      //             className="m-r-15 text-muted"
      //             data-toggle="tooltip"
      //             data-placement="top"
      //             title=""
      //             data-original-title="Edit"
      //           >
      //             <i className="f-20 icofont icofont-ui-edit text-custom"></i>
      //           </Link>
      //           <span
      //             onClick={this.deleteUser.bind(this, id)}
      //             className="m-r-15 text-muted"
      //             data-toggle="tooltip"
      //             data-placement="top"
      //             title=""
      //             data-original-title="Delete"
      //           >
      //             <i className="f-20 icofont icofont-delete-alt text-danger"></i>{' '}
      //           </span>
      //         </div>
      //       );
      //     },
      //   },
      // },
    ];
    // const options = {
    //   filterType: 'dropdown',
    //   viewColumns: false,
    //   print: false,
    //   download: false,
    //   selectableRows: 'none',
    //   textLabels: {
    //     body: {
    //       noMatch: this.state.isSaving
    //         ? 'Loading data..!'
    //         : 'Sorry, No Users Found',
    //       toolTip: 'Sort',
    //       columnHeaderTooltip: (column) => `Sort for ${column.label}`,
    //     },
    //   },
    // };
    const options = {
      filter: false,
      viewColumns: false,
      print: false,
      download: false,
      search: true,
      selectableRows: 'none',
      textLabels: {
        body: {
          // noMatch: this.state.isSaving
          // 	? 'Loading data..!'
          // 	: 'Sorry, No Users Found',
          toolTip: 'Sort',
          columnHeaderTooltip: (column) => `Sort for ${column.label}`,
        },
      },
    };
    // return (
    //   <div className="pcoded-inner-content">
    //     <div className="main-body">
    //       <div className="page-wrapper">
    //         <div className="row">
    //           <div className="col-sm-12">
    //             <div className="card">
    //               <div className="card-header">
    //                 <h5>Payment List</h5>
    //                 <Link
    //                   to="/payment/add"
    //                   className="btn btn-sm btn-inverse waves-effect waves-light f-right d-inline-block md-trigger"
    //                   data-modal="modal-13"
    //                 >
    //                   {' '}
    //                   <i className="icofont icofont-plus m-r-5"></i> Add Payment
    //                 </Link>
    //               </div>
    //               <div className="card-block">
    //                 <div className="dt-responsive table-responsive">
    //                   <MUIDataTable
    //                     title={'Payment List'}
    //                     className="table-responsive"
    //                     data={this.state.user_list}
    //                     columns={columns}
    //                     options={options}
    //                   />
    //                 </div>
    //               </div>
    //             </div>
    //           </div>
    //         </div>
    //       </div>
    //     </div>
    //   </div>
    // );
    return (
      <div className="pcoded-inner-content">
        <div className="main-body">
          <div className="page-wrapper">
            <div className="row">
              <div className="col-sm-12">
                <div className="card">
                  <div className="card-header">
                    <h5>Payment List</h5>
                  </div>
                  <div className="card-block">
                    <div className="dt-responsive table-responsive">
                      {this.props.home.paymentList !== undefined ? (
                        <MUIDataTable
                          title={'Payment List'}
                          className="table-responsive"
                          data={this.props.home.paymentList}
                          columns={columns}
                          options={options}
                        />
                      ) : (
                        <h4>Loading...</h4>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

PaymentList.propTypes = {
  getDateWisePayments: PropTypes.func.isRequired,
};

var mapStateToProps = (state) => {
  return {
    home: state.home,
  };
};

export default connect(mapStateToProps, { getDateWisePayments })(PaymentList);
